import React from "react";
import styled from "styled-components";
import theme from "../../../styles/theme";

const StyledNav = styled.nav`
  display: flex;
  flex-direction: column;
  font-family: 'Graphik', 'Graphik Web', 'Helvetica Neue',Helvetica,Arial,sans-serif;
  ${() => theme.media.desktopUp`
    display: block;
    flex: 1 1 0%;
    margin-left: 16px;
  `};
  ${() => theme.media.wideScreenUp`
    margin-left: 90px;
  `};
`;

const Nav = ({ children, className }) => {
  return <StyledNav className={className}>{children}</StyledNav>;
};

export default Nav;
